import moment from "moment";

const isNumber = n => typeof n === "number";

const filterDate = {
  formattedYearDate (date) {
    if (date) {
      // Unix timpstamp
      if (isNumber(date)) {
        const unix = moment.unix(String(date));
        return unix.format("YYYY/MM/DD");
      } else {
        return moment(date).format("YYYY/MM/DD");
      }
    }
    return "";
  },
};

export { filterDate };
